import React, { useState, useEffect } from 'react';
import apiFetch from '@wordpress/api-fetch';
import { renderInputRow } from '../../../utils/renderInputRow';
import { Button } from '../../../components/ui/index.jsx';
import { useToast } from '../../../components/ui/Toast.jsx';

const GeneralSettingTab = () => {
    const toast = useToast();
    const [originalGeneralSettings, setOriginalGeneralSettings] = useState({});
    const [generalSettings, setGeneralSettings] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const global = window.BPSFW_GLOBAL_OPTIONS || {};
        setGeneralSettings(global);
        setOriginalGeneralSettings(global);
    }, []);

    const mapKeyToOption = (key) => {
        const allowedKeys = [
            'wg_combo',
            'wg_cats_select2',
            'bpsfw_tags_select2',
            'wg_pags_select2'
        ];
    
        return allowedKeys.includes(key) ? key : null;
    };

    const handleSave = () => {
        const isEqualSelect2 = (a, b) => {
            const n = x => Array.isArray(x) ? x.map(i => (typeof i === 'object' ? String(i.id) : String(i))).sort() : [];
            return JSON.stringify(n(a)) === JSON.stringify(n(b));
        };
        const changedData = {};
        Object.entries(generalSettings).forEach(([key, value]) => {
            const optionKey = mapKeyToOption(key);
            if (optionKey) {
                if (!isEqualSelect2(originalGeneralSettings[key], value)) {
                    changedData[optionKey] = value.map(v =>
                        (typeof v === 'object' && v.id && v.text)
                            ? { id: String(v.id), text: String(v.text) }
                            : { id: String(v), text: '' }
                    );
                }
            } else {
                if (String(originalGeneralSettings[key]) !== String(value)) changedData[key] = value;
            }
        });

        if (Object.keys(changedData).length === 0) {
            toast.info('No changes detected.');
            return;
        }

        setLoading(true);
        apiFetch({ path: '/wp/v2/settings', method: 'POST', data: changedData })
            .then(() => {
                toast.success('General settings saved successfully!');
                window.BPSFW_GLOBAL_OPTIONS = { ...(window.BPSFW_GLOBAL_OPTIONS || {}), ...generalSettings };
                setOriginalGeneralSettings(generalSettings);
            })
            .catch((err) => {
                console.error('Error saving general settings:', err);
                toast.error('Error saving general settings.');
            })
            .finally(() => setLoading(false));
    };

    const updateGeneralSetting = (key, value) => setGeneralSettings(prev => ({ ...prev, [key]: value }));
    const Roles = window.BPSFW_GLOBAL_ROLES || {};

    return (
        <div className="plugin-notification-setting-tab">
            {loading && (
                <div className="bpsfw-overlay-loader">
                    <div className="bpsfw-loader-box">
                        <div className="bpsfw-spinner"></div>
                        <span className="bpsfw-loader-text">Saving changes…</span>
                    </div>
                </div>
            )}

            <div className="bpsfw-section-card">
                <div className="bpsfw-section-header">
                    <div className="bpsfw-section-icon">⚙️</div>
                    <div>
                        <div className="bpsfw-section-title">Common Settings</div>
                        <div className="bpsfw-section-subtitle">Global store access controls</div>
                    </div>
                </div>
                <div className="bpsfw-section-body">
                    
                    {renderInputRow('Privatize', 'bpsfw_privatize_option', 'radioGroup', [
                        { label: 'Whole Website', value: 'whole_website' },
                        { label: 'WooCommerce Store', value: 'woocommerce_store' },
                        { label: 'Selected Items', value: 'selected_items' }
                    ], '', '', generalSettings, updateGeneralSetting)}

                    <div style={{ display: generalSettings.bpsfw_privatize_option === 'selected_items' ? 'block' : 'none', marginBottom: '16px' }}>
                        {renderInputRow('Private Products', 'wg_combo', 'select2', [], '', 'bpsfw_select_product', generalSettings, updateGeneralSetting)}
                        {renderInputRow('Private Categories', 'wg_cats_select2', 'select2', [], '', 'bpsfw_select_cats', generalSettings, updateGeneralSetting, '', true)}
                        {renderInputRow('Private Tags', 'bpsfw_tags_select2','select2', [], '', 'bpsfw_select_tags', generalSettings, updateGeneralSetting, '', true)}
                        {renderInputRow('Private Pages', 'wg_pags_select2', 'select2', [], '', 'wg_select_pags',       generalSettings, updateGeneralSetting)}
                    </div>

                    {renderInputRow('Hide Price & Add to Cart for Private Products', 'bpsfw_disble_price_addtocartbutton', 'checkBox', [], 'Enable', '', generalSettings, updateGeneralSetting,
                            <p className="description"><strong>Enabled:</strong> Products visible, but price & cart hidden.<br/><strong>Disabled:</strong> Products hidden entirely from guests.</p>
                    )}
                    {renderInputRow('User Login Redirect URL', 'bpsfw_redirect_url', '', [], '', '', generalSettings, updateGeneralSetting)}
                    {renderInputRow('Redirect URL for Private Products & Pages', 'bpsfw_prod_redirect_url', '', [], '', '', generalSettings, updateGeneralSetting,
                        <p className="description">Redirect users who try to access private products or pages. Default: <strong>{generalSettings.my_account_url}</strong></p>
                    )}
                </div>
            </div>

            <div className="bpsfw-save-row">
                <Button variant="primary" onClick={handleSave}>Save Changes</Button>
            </div>
        </div>
    );
};

export default GeneralSettingTab;
